import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import dayjs, { Dayjs } from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useUpdateActivityMutation } from '../../hooks/mutations/useActivityMutation';
import { useBoolean } from '../../hooks/useBoolean';
import { DataItem } from '../../services/apiSLTP/dailyReports/activities';

interface StartTimeCellProps {
    activity: DataItem;
    disabled?: boolean;
    refetch: () => void;
}

const StartTimeCell: React.FC<StartTimeCellProps> = ({ activity, disabled = false, refetch }) => {
    const timeModal = useBoolean(false);
    const [localTime, setLocalTime] = useState<Dayjs | null>(dayjs(activity.startTime));

    const { mutate: updateActivity } = useUpdateActivityMutation({
        onSuccess: () => {
            refetch();
        },
    });

    const handleTimeChange = (time: string) => {
        updateActivity({ id: activity._id, body: { startTime: time } });
    };

    useEffect(() => {
        setLocalTime(dayjs(activity.startTime));
    }, [activity.startTime]);

    return (
        <TimePicker
            ampm={false}
            onChange={(value) => setLocalTime(value)}
            onAccept={(value) => (value ? handleTimeChange(value?.toISOString()) : null)}
            value={localTime}
            open={timeModal.value}
            onClose={() => timeModal.setFalse()}
            slotProps={{
                field: {
                    readOnly: true,
                },
                textField: {
                    variant: 'standard',
                    onClick: disabled ? () => {} : () => timeModal.setTrue(),
                    sx: {
                        width: 50,
                        textAlign: 'center',
                        '& .MuiInputBase-input': {
                            textAlign: 'center',
                        },
                        '& .MuiInputBase-root.Mui-disabled .MuiInputBase-input': {},

                        '& .MuiInput-underline:before': {},
                        '& .MuiInput-underline:after': {},
                    },
                },
                inputAdornment: {
                    sx: {
                        display: 'none',
                    },
                },
            }}
            sx={{
                borderRadius: '10px',
                '& .MuiOutlinedInput-root': {
                    borderRadius: '10px',
                },
            }}
            disabled={disabled}
        />
    );
};

export default StartTimeCell;
